import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { push } from 'connected-react-router'
import { bindPromiseCreators } from '../../../utils/routines'
import '../../../utils/validations/extendYup'
import { stepStatuses } from '../constants'
import { withCreateApplySaga } from '../saga'
import { createCreateApplyPromise } from '../routines'
import { getApplyToStepPath } from '../../MainRoutes/utils'

const mapDispatchToProps = dispatch => ({
  ...bindPromiseCreators({
    createApply: createCreateApplyPromise
  }, dispatch),
  ...bindActionCreators({
    redirectTo: push
  }, dispatch)
})
const connector = connect(null, mapDispatchToProps)

// formik
export const mapPropsToValues = () => ({
  power: false
})
export const validationSchema = yup.object().shape({
  power: yup
    .bool()
    .isTrue()
    .required()
})

export async function handleSubmit(values, {
  setSubmitting,
  setStatus,
  props: {
    createApply,
    handleClose,
    redirectTo
  }
}) {
  try {
    const response = await createApply(values)
    handleClose()

    const nextPath = getApplyToStepPath(
      stepStatuses.SOLICITUDE,
      { id: response.result.response }
    )
    return redirectTo(nextPath)
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}

export const formik = withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit,
  validateOnBlur: false
})

export default compose(
  withCreateApplySaga,
  connector,
  formik
)
